import { AlertModal } from '@festo-ui/react';
import { LoadingSpinner } from 'festo-react-ui-kit';
import ReactDOM from 'react-dom';
import { RequestHandler } from '../../../../app/RequestHandler';
import { replaceLocale } from '../../../../features/base/helpers/helper';
import useTranslation from '../../../../features/translation/hooks/useTranslation';
import { econdaClickEvent } from '../../../../Econda';
import { useLocation } from 'react-router';

interface OverlayProps {
  open: boolean;
  loading: boolean;
  onClose: () => void;
}

enum TranslationKeys {
  SUCCESS = 'successModal',
  DESCRIPTION = 'basketDescriptionModal',
  PRICE_DISCLAIMER = 'basketPriceDisclaimerModal',
  CONTINUE_SHOPPING = 'continueToShoppingModal',
  CONTINUE_TO_CART = 'continueToCartModal',
  TITLE = 'basketTitleModal',
}

const modalDiv = document.getElementById('shock-absorber-modal');

export default function Overlay({ open, loading, onClose }: OverlayProps, callback: () => void): JSX.Element {
  const t = useTranslation();
  const { country, language } = new RequestHandler();
  const { pathname } = useLocation();

  function handleOk() {
    econdaClickEvent(pathname, 'primary button', 'continue to cart', 'click');
    onClose();
    const url = `${process.env.REACT_APP_FESTO_URL}${replaceLocale(
      `${process.env.REACT_APP_GO_TO_BASKET_URL}`,
      language,
      country,
    )}`;
    window.open(url, '_self');
  }

  function handleCancel() {
    econdaClickEvent(pathname, 'primary button', 'cancel go to cart', 'click');
    onClose();
  }

  function handleClose() {
    if (open === true) {
      econdaClickEvent(pathname, 'primary button', 'close go to cart', 'click');
      onClose();
    }
  }

  return modalDiv ? (
    ReactDOM.createPortal(
      <>
        <AlertModal
          alertType="info"
          subtitle={t(TranslationKeys.SUCCESS)}
          className="shock-absorber-modal"
          isOpen={open}
          onOk={handleOk}
          onClose={handleClose}
          onCancel={handleCancel}
          body={`${t(TranslationKeys.DESCRIPTION)} ${t(TranslationKeys.PRICE_DISCLAIMER)}`}
          ok={t(TranslationKeys.CONTINUE_TO_CART)}
          cancel={t(TranslationKeys.CONTINUE_SHOPPING)}
          title={t(TranslationKeys.TITLE)}
        />
        {loading && <LoadingSpinner />}
      </>,
      modalDiv,
    )
  ) : (
    <></>
  );
}
